import axios from '@/utils/request';
const prefix = process.env.VUE_APP_API_PREFIX_1;

// 获取token
const getToken = params => {
  return axios.get(`${prefix}/getToken`);
};

// 根据token获取用户信息
const GetInfoByToken = params => {
  return axios.get(`${prefix}/GetInfoByToken`);
};

// 新增第一个用户
const CreateSystemFirstUser = data => {
  return axios.post(`${prefix}/CreateSystemFirstUser`, data);
};

// 错误码
const KeyErrorCode = params => {
  return axios.get(`${prefix}/errcode`, { params });
};

// 获取网关虚拟网络参数
const GetNetworkParams = params => {
  return axios.get(`${prefix}/GetNetworkParams`, { params });
};

// 账号登录
const Login = data => {
  return axios.post(`${prefix}/Login`, data);
};

// 验证码登录
const SmsLogin = data => {
  return axios.post(`${prefix}/SmsLogin`, data);
};

// 扫码登录
const ScanLogin = data => {
  return axios.post(`${prefix}/ScanLogin`, data);
};

// 获取验证码
const GetSmsCode = params => {
  return axios.get(`${prefix}/GetSmsCode`, { params });
};

// 获取系统设置
const GetSetting = params => {
  return axios.get(`${prefix}/GetSetting`, { params });
};

// 设置系统信息
const SetSetting = data => {
  return axios.post(`${prefix}/SetSetting`, data);
};

// 设置关于我们
const UpdateAboutUs = data => {
  return axios.post(`${prefix}/UpdateAboutUs`, data);
};

// 上传文件
const UploadFile = data => {
  return axios.request({
    method: 'POST',
    url: `${prefix}/UploadFile`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 发送测试邮件
const SendTestEmail = data => {
  return axios.post(`${prefix}/SendTestEmail`, data);
};

// 获取邮箱验证码
const SendEmailCode = params => {
  return axios.get(`${prefix}/SendEmailCode`, { params });
};

// 获取系统设置单独项
const GetSettingHideValue = params => {
  return axios.get(`${prefix}/GetSettingHideValue`, { params });
};

// 重新生成API_KEY
const ResetApikey = data => {
  return axios.post(`${prefix}/ResetApikey`, data);
};

// 获取平台首位用户信息
const GetSystemCustomerInfo = params => {
  return axios.get(`${prefix}/GetSystemCustomerInfo`, { params });
};

// 获取平台是否已经初始化
const GetInitStatus = params => {
  return axios.get(`${prefix}/GetInitStatus`, { params });
};

export {
  getToken,
  GetInfoByToken,
  CreateSystemFirstUser,
  KeyErrorCode,
  GetNetworkParams,
  Login,
  SmsLogin,
  ScanLogin,
  GetSmsCode,
  GetSetting,
  SetSetting,
  UpdateAboutUs,
  UploadFile,
  SendTestEmail,
  SendEmailCode,
  GetSettingHideValue,
  ResetApikey,
  GetSystemCustomerInfo,
  GetInitStatus,
};
